import { j as r } from "../../../../node_modules/react/jsx-runtime.js";
import { createContext as u, useContext as x, useMemo as p } from "react";
import { useSortable as v } from "../../../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js";
import { CSS as b } from "../../../../node_modules/@dnd-kit/utilities/dist/utilities.esm.js";
import g from "../../Icon/Icon.js";
const i = u({
  attributes: {},
  listeners: void 0,
  ref() {
  }
});
function R({ children: e, id: o }) {
  const {
    attributes: t,
    isDragging: a,
    listeners: s,
    setNodeRef: m,
    setActivatorNodeRef: n,
    transform: c,
    transition: f
  } = v({ id: o }), l = p(
    () => ({
      attributes: t,
      listeners: s,
      ref: n
    }),
    [t, s, n]
  ), d = {
    opacity: a ? 0.4 : void 0,
    transform: b.Translate.toString(c),
    transition: f
  };
  return /* @__PURE__ */ r.jsx(i.Provider, { value: l, children: /* @__PURE__ */ r.jsx(
    "div",
    {
      ref: m,
      style: d,
      children: e
    }
  ) });
}
const h = () => {
  const { attributes: e, listeners: o, ref: t } = x(i);
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      ref: t,
      className: "cursor-pointer",
      ...e,
      ...o,
      children: /* @__PURE__ */ r.jsx(g, { name: "dots-grid" })
    }
  );
};
export {
  h as DragHandler,
  R as SortableItem
};
//# sourceMappingURL=helper.js.map
